import React from 'react'
import BodySection from '../../../components/AdminDashboard/ClubSubscription/NewPackage/BodySection'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const NewPackage = () => {
    return (
        <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>
            
            {/* Side nav */}
            <SideNav />

            {/* Setting Body */}
            <BodySection />

        </div>
    )
}

export default NewPackage